import {Injectable} from '@angular/core';
import {BaseResponse, User, EnterCausesResponse} from '../core/core.component';
import {Http, Headers, URLSearchParams} from '@angular/http';
import {AppConstants} from '../core/app.constants';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';
import {Subject} from 'rxjs/Subject';
import { environment } from 'environments/environment';

@Injectable()
export class UserOptionsService {

  private userOptionsComponentStatus = new Subject<User>();

  constructor(private http: Http) {}
  

  getOptions(srmToken, userId: number): Observable<EnterCausesResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/access/options';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    const params: URLSearchParams = new URLSearchParams();
    params.append('idUser', String(userId));
    return this.http.get(url, {search: params, headers: headers}).map((responseData) => responseData.json());
  }

  insertUserOptions(srmToken, userId: number, optId: number): Observable<BaseResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/access/insertUserOpt';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    let  body = {
      userId: userId,
      optId: optId
    };
    return this.http.put(url, body, {headers: headers}).map((responseData) => responseData.json());
  }

  deleteUserOptions(srmToken, userId: number, optId: number): Observable<BaseResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/access/deleteUserOpt';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    const params: URLSearchParams = new URLSearchParams();
    params.append('userId', String(userId));
    params.append('optId', String(optId));
    return this.http.delete(url, {search: params, headers: headers}).map((responseData) => responseData.json());
  }

  getOptUser(srmToken, userId?: number): Observable<EnterCausesResponse> {
    let url = environment.REST_SERVICE_BASE_URL + '/access/userOpt';
    url = AppConstants.urlForNoCache(url);
    const headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    const params: URLSearchParams = new URLSearchParams();
    
    if (userId != null && typeof (userId) !== 'undefined') {
      params.append('userId', String(userId));
    }
    
    return this.http.get(url, {search: params, headers: headers}).map((responseData) => responseData.json());
  }

  getUserOptionsComponentStatus(): Observable<User> {
    return this.userOptionsComponentStatus.asObservable();
  }

  openUserOptionsComponent(user: User) {
    this.userOptionsComponentStatus.next(user);
  }

  closeUserOptionsComponent() {
    this.userOptionsComponentStatus.next();
  }

}



// WEBPACK FOOTER //
// ./src/app/service/userOptions.service.ts